module.exports = __webpack_public_path__ + "img/exportWordWhite.aa26e74b.svg";